import React from 'react';
import Icon from '../Icon/Icon';
import styles from './ViewLinkButton.module.css';

interface ViewLinkButtonProps {
  label?: string;
  icon?: string | null;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  truncate?: boolean;
  'aria-label'?: string;
}

const ViewLinkButton: React.FC<ViewLinkButtonProps> = ({
  label = 'Ver',
  icon = 'visibility',
  onClick,
  disabled = false,
  className = '',
  truncate = false,
  'aria-label': ariaLabel,
}) => {
  return (
    <button
      type="button"
      className={[
        styles['link-view'],
        truncate ? styles.truncate : '',
        className,
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {icon ? (
        <Icon name={icon} size={16} color="var(--color-accent-brown)" />
      ) : null}
      <span className={styles['link-view-text']}>{label}</span>
    </button>
  );
};

export default ViewLinkButton;
